export const settingsMock = {
    settings: {
        accountAssociationModal: {
            isAccountAssociationModalOpen: false,
        },
        updateUserSettings: {
            isModalOpen: true,
            error: null,
            loading: false,
        },
    },
};
